import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/paypage/topDate.svg'
import _imports_1 from '@/assets/paypage/topKefu.svg'
import _imports_2 from '@/assets/paypage/topPercen.svg'
import _imports_3 from '@/assets/paypage/topSafe.svg'
import _imports_4 from '@/assets/paypage/cart.svg'
import _imports_5 from './img/message-gou.svg'
import _imports_6 from './img/pickGou.svg'
import _imports_7 from '@/assets/paypage/features1.svg'
import _imports_8 from '@/assets/paypage/right.svg'
import _imports_9 from '@/assets/paypage/features2.svg'
import _imports_10 from '@/assets/paypage/features3.svg'
import _imports_11 from './img/image1.svg'
import _imports_12 from './img/image2.svg'
import _imports_13 from './img/image3.svg'
import _imports_14 from './img/image4.svg'
import _imports_15 from './img/image5.svg'
import _imports_16 from './img/image6.svg'
import _imports_17 from './img/image7.svg'
import _imports_18 from './img/image8.svg'


const _withScopeId = n => (_pushScopeId("data-v-eea402b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payPage" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "whole" }
const _hoisted_4 = { class: "wholeBox" }
const _hoisted_5 = { class: "wholeItem" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "wholeItem" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = { class: "wholeItem" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_11 = { class: "wholeItem" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "selectBox" }
const _hoisted_14 = { class: "middle" }
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "price" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "delPrice" }, "$85.99", -1))
const _hoisted_18 = { class: "current" }
const _hoisted_19 = { class: "button" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_21 = { class: "first" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "img"
}, null, -1))
const _hoisted_23 = { class: "dec" }
const _hoisted_24 = { class: "first" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "img"
}, null, -1))
const _hoisted_26 = { class: "dec" }
const _hoisted_27 = { class: "first" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "img"
}, null, -1))
const _hoisted_29 = { class: "dec" }
const _hoisted_30 = { class: "first" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "img"
}, null, -1))
const _hoisted_32 = { class: "dec" }
const _hoisted_33 = { class: "save" }
const _hoisted_34 = { class: "saveText" }
const _hoisted_35 = { class: "price recommend" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "delPrice" }, "$55.99", -1))
const _hoisted_37 = { class: "current" }
const _hoisted_38 = {
  class: "button",
  style: {"margin-top":"16px"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2 3H3.75L4.5 6M4.5 6L7 16H20L22.5 6H4.5Z",
    stroke: "#2DB249",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 21C7.82843 21 8.5 20.3284 8.5 19.5C8.5 18.6716 7.82843 18 7 18C6.17157 18 5.5 18.6716 5.5 19.5C5.5 20.3284 6.17157 21 7 21Z",
    fill: "#2DB249"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20 21C20.8284 21 21.5 20.3284 21.5 19.5C21.5 18.6716 20.8284 18 20 18C19.1716 18 18.5 18.6716 18.5 19.5C18.5 20.3284 19.1716 21 20 21Z",
    fill: "#2DB249"
  })
], -1))
const _hoisted_40 = { class: "first" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_42 = { class: "dec" }
const _hoisted_43 = { class: "first" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_45 = { class: "dec" }
const _hoisted_46 = { class: "first" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_48 = { class: "dec" }
const _hoisted_49 = { class: "first" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "img"
}, null, -1))
const _hoisted_51 = { class: "dec" }
const _hoisted_52 = { class: "price" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "delPrice" }, "$55.99", -1))
const _hoisted_54 = { class: "current" }
const _hoisted_55 = { class: "button" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_57 = { class: "first" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "img"
}, null, -1))
const _hoisted_59 = { class: "dec" }
const _hoisted_60 = { class: "first" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "img"
}, null, -1))
const _hoisted_62 = { class: "dec" }
const _hoisted_63 = { class: "first" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "img"
}, null, -1))
const _hoisted_65 = { class: "dec" }
const _hoisted_66 = { class: "first" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "img"
}, null, -1))
const _hoisted_68 = { class: "dec" }
const _hoisted_69 = { class: "middleTitle" }
const _hoisted_70 = { class: "middleEquity" }
const _hoisted_71 = { class: "itemBox ul1" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "",
  class: "itemImg"
}, null, -1))
const _hoisted_73 = { class: "itemP" }
const _hoisted_74 = { class: "itemul" }
const _hoisted_75 = { class: "itemli" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_77 = { class: "itemBox ul2" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: "",
  class: "itemImg"
}, null, -1))
const _hoisted_79 = { class: "itemP" }
const _hoisted_80 = { class: "itemul" }
const _hoisted_81 = { class: "itemli" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_83 = { class: "itemBox ul3" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: "",
  class: "itemImg"
}, null, -1))
const _hoisted_85 = { class: "itemP" }
const _hoisted_86 = { class: "itemul" }
const _hoisted_87 = { class: "itemli" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_89 = /*#__PURE__*/_createStaticVNode("<div class=\"bottom\" data-v-eea402b0><div class=\"row\" data-v-eea402b0><img src=\"" + _imports_11 + "\" data-v-eea402b0><img src=\"" + _imports_12 + "\" data-v-eea402b0><img src=\"" + _imports_13 + "\" data-v-eea402b0><img src=\"" + _imports_14 + "\" data-v-eea402b0><img src=\"" + _imports_15 + "\" data-v-eea402b0><img src=\"" + _imports_16 + "\" data-v-eea402b0><img src=\"" + _imports_17 + "\" data-v-eea402b0><img src=\"" + _imports_18 + "\" data-v-eea402b0></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_contactDialog = _resolveComponent("contactDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t('famikeep210.FamiKeep - Parental Control App Pricing & Plans')) + " ", 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.30-Day Money Back Guarantee')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.Professional Customer Support')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.All Prices Exclusive of VAT')), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep210.100% Secure')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: _normalizeClass(["box pointer", _ctx.selectedDeviceType ? '' : 'active']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeSelectedDeviced(0)))
          }, "Android ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["box pointer", _ctx.selectedDeviceType ? 'active' : '']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeSelectedDeviced(1)))
          }, "IOS", 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_el_row, { class: "elRow" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "single",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.choseMeal(1)))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["plan", _ctx.lang == 'ar' ? 'reverse1' : ''])
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("payPage.one")), 1)
                  ], 2),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("span", _hoisted_18, "$" + _toDisplayString(_ctx.conins[2]) + "/Mon", 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("a", {
                      class: "goToBuy",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToBuyFun(1)))
                    }, [
                      _hoisted_20,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("payPage.toBuy")), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["message", _ctx.lang == 'ar' ? 'reverse1' : ''])
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("payPage.update")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("payPage.collect")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("payPage.interaction")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("payPage.hide")), 1)
                    ])
                  ], 2)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "single active",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.choseMeal(2)))
                }, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("payPage.bigSave")), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["plan", _ctx.lang == 'ar' ? 'reverse1' : ''])
                  }, _toDisplayString(_ctx.$t("payPage.three")), 3),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("span", _hoisted_37, "$" + _toDisplayString(_ctx.conins[1]) + "/ Day", 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("a", {
                      class: "goToBuy",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToBuyFun(2))),
                      style: {"min-width":"272px"}
                    }, [
                      _hoisted_39,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("payPage.toBuy")), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["message", _ctx.lang == 'ar' ? 'reverse1' : ''])
                  }, [
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t("payPage.update")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("payPage.collect")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t("payPage.interaction")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t("payPage.hide")), 1)
                    ])
                  ], 2)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "single",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.choseMeal(3)))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["plan", _ctx.lang == 'ar' ? 'reverse1' : ''])
                  }, _toDisplayString(_ctx.$t("payPage.year")), 3),
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("span", _hoisted_54, "$" + _toDisplayString(_ctx.conins[0]) + "/ Year", 1)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("a", {
                      class: "goToBuy",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToBuyFun(3)))
                    }, [
                      _hoisted_56,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("payPage.toBuy")), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["message", _ctx.lang == 'ar' ? 'reverse1' : ''])
                  }, [
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t("payPage.update")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _hoisted_61,
                      _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t("payPage.collect")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _hoisted_64,
                      _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t("payPage.interaction")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _hoisted_67,
                      _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$t("payPage.hide")), 1)
                    ])
                  ], 2)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t('famikeep210.More Features to Keep Your Kids Safe Online')), 1),
      _createElementVNode("div", _hoisted_70, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 8,
              class: "elCol"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_71, [
                  _hoisted_72,
                  _createElementVNode("p", _hoisted_73, _toDisplayString(_ctx.$t('famikeep210.Features')), 1),
                  _createElementVNode("div", _hoisted_74, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feature1, (item) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_75, [
                        _hoisted_76,
                        _createElementVNode("span", null, _toDisplayString(item), 1)
                      ]))
                    }), 256))
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 8,
              class: "elCol"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_77, [
                  _hoisted_78,
                  _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.$t('famikeep210.Monitor App')), 1),
                  _createElementVNode("div", _hoisted_80, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feature2, (item) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_81, [
                        _hoisted_82,
                        _createElementVNode("span", null, _toDisplayString(item), 1)
                      ]))
                    }), 256))
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 8,
              class: "elCol"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_83, [
                  _hoisted_84,
                  _createElementVNode("p", _hoisted_85, _toDisplayString(_ctx.$t('famikeep210.Type of Data')), 1),
                  _createElementVNode("div", _hoisted_86, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feature3, (item) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_87, [
                        _hoisted_88,
                        _createElementVNode("span", null, _toDisplayString(item), 1)
                      ]))
                    }), 256))
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_89,
    _createVNode(_component_contactDialog, {
      visible: _ctx.showContact,
      onToCancle: _ctx.closeContact
    }, null, 8, ["visible", "onToCancle"])
  ]))
}